import React from 'react';
import Navigation from './Navigation';

const Header = () => {
  return (
    <header className="header">
      <h1 className="title">Bikerentalmap</h1>
      <Navigation />
    </header>
  );
};

export default Header;
